/**
 * Determines if a practice matches selected land cover and/or priority filters.
 * @param {Object} practice - The transformed practice object.
 * @param {Array} landCoverSelections - Selected land cover types.
 * @param {Array} prioritySelections - Selected priority types.
 * @returns {boolean} True if the practice should be shown.
 */
export const isPracticeVisible = (
  practice,
  landCoverSelections = [],
  prioritySelections = []
) => {
  if (!practice || typeof practice !== "object") return false;

  const hasLandCover = landCoverSelections.length > 0;
  const hasPriorities = prioritySelections.length > 0;

  // If no filters are selected, show all
  if (!hasLandCover && !hasPriorities) return true;

  // Check landcover match
  if (hasLandCover) {
    const matchesLandCover = landCoverSelections.some((type) =>
      practice.landcover?.includes(type)
    );
    if (!matchesLandCover) return false;
  }

  // Check priority match
  if (hasPriorities) {
    const priorityNames = practice.priorities?.map((p) => p.name) || [];
    const matchesPriority = prioritySelections.some((key) =>
      priorityNames.includes(key)
    );
    if (!matchesPriority) return false;
  }

  return true;
};
